import {axios} from ".";
import config from '../config.json';

export const createTemplate = async (categoryID,templateID) => {
  try{
    const {
      data
    } = await axios.post(`${config.base_url_api}/templatecategory/`,{categoryID,templateID});
    return data;
  }catch(error)
  {
    throw new Error(error)
  }
}
export const deleteTemplate = async (ID) => {
  try{
    const {
      data
    } = await axios.delete(`${config.base_url_api}/templatecategory/${ID}`);
    return data;
  }catch(error)
  {
    throw new Error(error)
  }
}


